export default __webpack_public_path__ + "static/media/wait-time.062d10af.svg";